import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import SectionIndex from "@/pages/home/components/SectionIndex";
import FeaturedGallery from "@/pages/home/components/FeaturedGallery";
import CategoryBrowser from "@/pages/home/components/CategoryBrowser";
import WallpaperZone from "@/pages/home/components/WallpaperZone";
import LifestyleList from "@/pages/home/components/LifestyleList";
import StyleGuide from "@/pages/home/components/StyleGuide";
import BrowseTips from "@/pages/home/components/BrowseTips";
import Faq from "@/pages/home/components/Faq";
import Newsletter from "@/pages/home/components/Newsletter";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <SectionIndex />
        <FeaturedGallery />
        <CategoryBrowser />
        <WallpaperZone />
        <LifestyleList />
        <StyleGuide />
        <BrowseTips />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}